import { createTheme, ThemeOptions } from '@mui/material/styles'
import type {} from '@mui/x-date-pickers/themeAugmentation'

export const colors = {
  Green: '#009187',
  LightGreen: '#F5FCFA',
  Gray2: '#EFF0F1',
  White: '#FFFFFF',
  Black: '#050F1E',
  Gray5: '#4B525D',
  Gray4: '#8A8F96',
  Gray3: '#CDCFD2',
  Gray1: '#F5F6F6',
  Red: '#FF2D55',
  Pink: '#FFE4E9',
}

export const appBarHeight = 65
export const sideBarWidth = 320

const defaultTheme = createTheme()

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      light: colors.LightGreen,
      main: colors.Green,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: colors.Pink,
      main: colors.Red,
      //   dark: will be calculated from palette.secondary.main,
      //   contrastText: '#ffcc00',
    },
    error: {
      main: colors.Red,
    },
    text: {
      primary: colors.Black,
      secondary: colors.Gray5,
      disabled: colors.Gray4,
    },
    divider: colors.Gray3,
    action: {
      active: colors.Gray5,
      disabledBackground: colors.Gray4,
    },
    background: {
      default: colors.Gray2,
      paper: colors.White,
    },
  },
  // NOTE: 各コンポーネントの Global class の名前を参照してthemeで変更できないデフォルトカラーを変更
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.Gray2,
          fontFamily: 'Roboto',
          fontSize: '0.875rem',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        maxWidthMd: {
          maxWidth: 1088,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontSize: 18,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: colors.Black,
        },
        arrow: {
          '&::before': {
            backgroundColor: colors.Black,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          minWidth: 64,
          padding: '6px 16px',
          letterSpacing: 1.25,
          textTransform: 'none',
          '&:disabled': {
            color: colors.Gray4,
          },
          '&:label': {
            whiteSpace: 'nowrap',
          },
        },
        contained: {
          boxShadow: 'none',
          '&:disabled': {
            color: 'white',
          },
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '16px 10.5px 16px 16px',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorDisabled: {
          color: colors.Gray4,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          [defaultTheme.breakpoints.up('sm')]: {
            minWidth: 80,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontSize: defaultTheme.typography.fontSize,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          paddingRight: 4,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          paddingRight: 4,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          paddingRight: 16,
          paddingLeft: 16,
        },
        inputMultiline: {
          paddingRight: 2,
          paddingLeft: 2,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginRight: 16,
          marginLeft: 16,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          marginRight: -4,
          marginLeft: -4,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: colors.Gray2,
            '&.Mui-focusVisible': {
              backgroundColor: colors.Gray2,
            },

            '&.MuiTouchRipple-child': {
              backgroundColor: colors.Gray2,
            },
          },
        },
      },
    },
    MuiLink: { defaultProps: { underline: 'hover' } },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '&:hover': {
              backgroundColor: 'white',
            },
          },
        },
      },
    },
  },
}

export default createTheme(themeOptions)
